import {
    FETCH_PLANNING_ALERTS_REQUEST,
    FETCH_PLANNING_ALERTS_SUCCESS,
    FETCH_PLANNING_ALERTS_FAILURE,
    FETCH_PLANNING_ALERT_REQUEST,
    FETCH_PLANNING_ALERT_SUCCESS,
    FETCH_PLANNING_ALERT_FAILURE,
    CREATE_PLANNING_ALERT_REQUEST,
    CREATE_PLANNING_ALERT_SUCCESS,
    CREATE_PLANNING_ALERT_FAILURE,
    UPDATE_PLANNING_ALERT_REQUEST,
    UPDATE_PLANNING_ALERT_SUCCESS,
    UPDATE_PLANNING_ALERT_FAILURE,
    DELETE_PLANNING_ALERT_REQUEST,
    DELETE_PLANNING_ALERT_SUCCESS,
    DELETE_PLANNING_ALERT_FAILURE,
    SET_CURRENT_PLANNING_REPORT,
    FETCH_PLANNING_REPORT_REQUEST,
    FETCH_PLANNING_REPORT_SUCCESS,
    FETCH_PLANNING_REPORT_FAILURE,
    FETCH_PLANNING_ALERT_REPORTS_REQUEST,
    FETCH_PLANNING_ALERT_REPORTS_SUCCESS,
    FETCH_PLANNING_ALERT_REPORTS_FAILURE
} from './Types';

import {
    SET_FORM_PROPERTIES,
    SET_AREA_FACET,
    SET_AREA_FACET_VALUE,
    SET_AREA_GEOJSON,
    SET_AREA_CRITERIA,
    SET_AREA_LAYER
} from '../search_area/Types';

import {
    FETCH_CURRENT_PROJECT_SUCCESS,
    SET_CURRENT_PROJECT_SUCCESS
} from '../project/Types';

import { PLANNING_REDUCER } from '../ReducerNames';
import areaReducer from '../search_area/Reducer';
import { IPlanningAction, IPlanningReducerState } from './planningTypes';

const defaultState = {
    isCreating: false,
    isFetching: false,
    planningAlerts: [],
    currentPlanningAlertId: null, // The current planning alert

    planningAlertForm: {
        ...areaReducer(PLANNING_REDUCER)(undefined, {}),
        layerId: 145,
        frequency: 'weekly',
        changeType: 'new only',
        sendEmail: true,
        sendAppNotification: true,
        name: '',
        description: ''
    },

    planningReports: [],
    currentPlanningReportId: null
};

export default function reducer(
    state: IPlanningReducerState = defaultState,
    action: IPlanningAction
) {
    switch (action.type) {
        case FETCH_PLANNING_ALERTS_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null
            };
        case FETCH_PLANNING_ALERTS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                planningAlerts: action.planningAlerts,
                error: null
            };
        case FETCH_PLANNING_ALERTS_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };

        case FETCH_PLANNING_ALERT_REQUEST:
            return updatePlanningAlert(state, action, {
                isFetching: true,
                error: null
            });
        case FETCH_PLANNING_ALERT_SUCCESS:
            return updatePlanningAlert(state, action, {
                isFetching: false,
                notFound: false,
                error: null
            });
        case FETCH_PLANNING_ALERT_FAILURE:
            return updatePlanningAlert(state, action, {
                isFetching: false,
                notFound: true,
                error: {
                    status: action.error.status,
                    statusText: action.error.statusText
                }
            });
        /*
        // case FETCH_PLANNING_ALERT_REQUEST:
        //     return {
        //         ...state,
        //         isFetching: true,
        //         error: null
        //     };
        // case FETCH_PLANNING_ALERT_SUCCESS:
        //     return {
        //         ...state,
        //         isFetching: false,
        //         planningAlertForm: {
        //             areaType: 'drawn',
        //             geojson: { geometry: action.search.area },
        //             facetId: action.search.areaFacet.id,
        //             facetValue: action.search.areaFacetValue,
        //             facetValid: true,
        //             criteria: action.search.criteria,
        //             layerId: action.search.layerId,
        //             isDirty: false
        //         },
        //         error: null
        //     };
        // case FETCH_PLANNING_ALERT_FAILURE:
        //     return {
        //         ...state,
        //         isFetching: false,
        //         error: action.error,
        //     };
        */
        case CREATE_PLANNING_ALERT_REQUEST:
            return {
                ...state,
                isCreating: true,
                error: null
            };
        case CREATE_PLANNING_ALERT_SUCCESS:
            return {
                ...state,
                planningAlerts: [...state.planningAlerts, action.planningAlert],
                currentPlanningAlertId: action.planningAlert.id,
                planningAlertForm: {
                    ...state.planningAlertForm,
                    isDirty: false
                },
                isCreating: false,
                error: null
            };
        case CREATE_PLANNING_ALERT_FAILURE:
            return {
                ...state,
                isCreating: false,
                error: action.error
            };

        case UPDATE_PLANNING_ALERT_REQUEST:
            return updatePlanningAlert(state, action, {
                isUpdating: true,
                error: null
            });
        case UPDATE_PLANNING_ALERT_SUCCESS:
            return updatePlanningAlert(state, action, {
                isUpdating: false,
                error: null
            });
        case UPDATE_PLANNING_ALERT_FAILURE:
            return updatePlanningAlert(state, action, {
                isUpdating: false,
                error: {
                    status: action.error.status,
                    statusText: action.error.statusText
                }
            });

        case DELETE_PLANNING_ALERT_REQUEST:
            return updatePlanningAlert(state, action, {
                isDeleting: true,
                error: null
            });
        case DELETE_PLANNING_ALERT_SUCCESS:
            return deletePlanningAlert(state, action);
        case DELETE_PLANNING_ALERT_FAILURE:
            return updatePlanningAlert(state, action, {
                isDeleting: false,
                error: {
                    status: action.error.status,
                    statusText: action.error.statusText
                }
            });

        case FETCH_PLANNING_ALERT_REPORTS_REQUEST:
            return updatePlanningAlert(state, action, {
                isFetchingPlanningReports: true,
                error: null
            });
        case FETCH_PLANNING_ALERT_REPORTS_SUCCESS:
            return updatePlanningAlert(state, action, {
                isFetchingPlanningReports: false,
                error: null
            });
        case FETCH_PLANNING_ALERT_REPORTS_FAILURE:
            return updatePlanningAlert(state, action, {
                isFetchingPlanningReports: false,
                error: {
                    status: action.error.status,
                    statusText: action.error.statusText
                }
            });

        case SET_AREA_FACET:
        case SET_AREA_FACET_VALUE:
        case SET_AREA_GEOJSON:
        case SET_AREA_CRITERIA:
        case SET_AREA_LAYER:
        case SET_FORM_PROPERTIES:
            return action.reducerName === PLANNING_REDUCER
                ? {
                      ...state,
                      planningAlertForm: areaReducer(PLANNING_REDUCER)(
                          state.planningAlertForm,
                          action
                      )
                  }
                : state;

        case SET_CURRENT_PLANNING_REPORT:
            return {
                ...state,
                currentPlanningReportId: action.id
            };
        case FETCH_PLANNING_REPORT_REQUEST:
            return {
                ...state,
                planningReports: updatePlanningReport(state, action, true)
            };
        case FETCH_PLANNING_REPORT_SUCCESS:
            return {
                ...state,
                planningReports: updatePlanningReport(state, action, false)
            };
        case FETCH_PLANNING_REPORT_FAILURE:
            return {
                ...state,
                planningReports: updatePlanningReport(state, action, false),
                error: {
                    status: action.error.status,
                    statusText: action.error.statusText
                }
            };
        // When the project is changed then clear the planning alerts
        case FETCH_CURRENT_PROJECT_SUCCESS:
        case SET_CURRENT_PROJECT_SUCCESS: {
            return {
                ...state,
                planningAlerts: [],
                currentPlanningAlertId: null,
                planningReports: [],
                currentPlanningReportId: null
            };
        }
        default:
            return state;
    }
}

function updatePlanningAlert(
    state: IPlanningReducerState,
    action: IPlanningAction,
    other = {}
) {
    const arr = [...state.planningAlerts];
    const id = action.id;
    const idx = arr.findIndex(item => item.id === id);
    if (idx !== -1) {
        arr[idx] = {
            ...arr[idx],
            ...(action.planningAlert || {}),
            ...other
        };
    } else {
        arr.push({
            id: id,
            ...(action.planningAlert || {}),
            ...other
        });
    }
    return {
        ...state,
        planningAlerts: arr
    };
    // return arr;
}

function deletePlanningAlert(state: IPlanningReducerState, action: IPlanningAction) {
    const arr = [...state.planningAlerts];
    const id = action.id;
    const idx = arr.findIndex(item => item.id === id);
    arr.splice(idx, 1);
    if (idx !== -1) {
        arr.splice(idx, 1);
    }
    return {
        ...state,
        planningAlerts: arr
    };
}

function updatePlanningReport(
    state: IPlanningReducerState,
    action: IPlanningAction,
    isFetching: boolean
) {
    const reports = [...state.planningReports];
    const id = action.id ? action.id : action.planningReport.id;
    const idx = reports.findIndex(report => report.id === id);
    if (idx !== -1) {
        reports[idx] = {
            ...reports[idx],
            ...(action.planningReport || {}),
            isFetching: isFetching
        };
    } else {
        reports.push({
            id: id,
            ...(action.planningReport || {}),
            isFetching: isFetching
        });
    }
    return reports;
}
